export class AiRankingReq {
  holdingId: number;
  contactsIds: number[];

  constructor() {}
}
